export const STEP_START = 'STEP_START'
export const STEP_COLLECT_INFO = 'STEP_COLLECT_INFO'
export const STEP_SHOW_QUOTE = 'STEP_SHOW_QUOTE'
export const STEP_HEALTH_QUESTIONS = 'STEP_HEALTH_QUESTIONS'
export const STEP_PAYMENT = 'STEP_PAYMENT'
export const STEP_ID = 'STEP_ID'
export const STEP_SIGNATURE = 'STEP_SIGNATURE'
export const STEP_NO_SIGNATURE = 'STEP_NO_SIGNATURE'
export const STEP_FINAL = 'STEP_FINAL'

export const STEP_ORDER = [
    STEP_START,
    STEP_COLLECT_INFO,
    STEP_SHOW_QUOTE,
    STEP_ID,
    STEP_PAYMENT,
    STEP_NO_SIGNATURE,
    STEP_FINAL
]


export const STEP_ORDER_WITH_HEALTH_Q = [
    STEP_START,
    STEP_COLLECT_INFO,
    STEP_SHOW_QUOTE,
    STEP_HEALTH_QUESTIONS,
    STEP_ID,
    STEP_PAYMENT,
    STEP_NO_SIGNATURE,
    STEP_FINAL
]

export const STEP_ORDER_READABLE = [
    "Uppfletting",
    "Grunnupplýsingar",
    "Tilboð",
    "Skilríki",
    "Greiðsluhögun",
    "Útbúa samningsgögn"
]

export const STEP_ORDER_READABLE_WITH_HEALTH_Q = [
    "Uppfletting",
    "Grunnupplýsingar",
    "Tilboð",
    "Viðbótarupplýsingar",
    "Skilríki",
    "Greiðsluhögun",
    "Útbúa samningsgögn"
]

export const determineAllOffers = (offerQueryParams) => {
    let allOfferTypes = [];

    if(Object.entries(offerQueryParams).length !== 0) {
        Object.keys(offerQueryParams).map((cust) => {
            Object.keys(offerQueryParams[cust]).map((offerType) => {
                if (offerQueryParams[cust][offerType] === true && !allOfferTypes.includes(offerType)) {
                    allOfferTypes.push(offerType)
                }
            })
        })
    }
    return allOfferTypes
}

export const getStepOrder = (offerQueryParams) => {
    let allOfferTypes = determineAllOffers(offerQueryParams);

    // if (allOfferTypes.includes("RIS") || allOfferTypes.includes("FOR") || allOfferTypes.includes("REN") || allOfferTypes.includes("VID")) {
    //     return STEP_ORDER_WITH_HEALTH_Q
    // } else {
    //     return STEP_ORDER
    // }
    return STEP_ORDER_WITH_HEALTH_Q
}

export const getStepOrderReadable = (offerQueryParams) => {

    return STEP_ORDER_READABLE_WITH_HEALTH_Q

    // let allOfferTypes = determineAllOffers(offerQueryParams);

    // if (allOfferTypes.includes("RIS") || allOfferTypes.includes("FOR") || allOfferTypes.includes("REN")) {
    //     return STEP_ORDER_READABLE_WITH_HEALTH_Q
    // } else {
    //     return STEP_ORDER_READABLE
    // }
}

export const CONTRACT_STATUS_WAITING = [
    "B",
    "BN",
    "BV",
    "CAT",
    "IGF",
    "IGFL",
    "KAUP",
    "LUC",
    "N",
    "NB",
    "NU",
    "NÝTT",
    "ÓVÞ",
    "ÓVÞL",
    "PRÓS",
    "SIS",
    "UPP",
    "UPPIGF",
    "UPPÓVÞ",
    "SKR"
]

export const CONTRACT_STATUS_ACTIVE = [
    "VG",
    "VT",
    "EV"
]

export const CONTRACT_STATUS_INACTIVE = [
    "ÓV",
    "GR",
    "ÓVI",
    "ÓVIGF",
    "ÓVT"
]

export const offerTypesForBeneficiaries = ["REN", "LEB", "RISLEB", "FOR"]


export const CONTRACT_STATUS_VID_SHOW_PDF_REPORT = [
    "VG",
    "ÓVIGF",
    "IGF",
    "ÓVÞ",
    "LUC",
    "PRÓS",
    "KAUP",
    "UPP",
    
]

export const CONTRACT_STATUS_VID_WAITING = [
    "N",
    "NU",
    "CAT",
    "BN",
    "BV",
    'B'
]


export const CONTRACTS_VISIBLE_MAPPING = {
    'LEB': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'REN': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RIS': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RU': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'UPR': {
        'VG': true,
        'ÓVIGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'FOR': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'VID': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'LUC': true,
        'PRÓS': true,
        'KAUP': true,
        'UPP': true,
        'B': true,
        'N': true,
        'NU': true,
        'CAT': true,
        'BN': true,
        "BV": true,
    },
    'VIDT': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'LUC': true,
        'PRÓS': true,
        'KAUP': true,
        'UPP': true,
        'B': true,
        'N': true,
        'NU': true,
        'CAT': true,
        'BN': true,
        "BV": true,
    },
    'RUP': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'VIDE': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'VIDTE': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RISU': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RISLEB': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'UPRU': {
        'VG': true,
        'ÓVIGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RISLEBSAM': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RISU60': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'RIS60': {
        'VG': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
    'KSP': {
        'VG': true,
        'B': true,
        "BV": true,
    },
    'FORE': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
                "BV": true,
    },
    'RENE': {
        'VG': true,
        'ÓVIGF': true,
        'IGF': true,
        'ÓVÞ': true,
        'B': true,
        "BV": true,
    },
}


export const CONTRACTS_INACTIVE_PAID_VISIBLE_MAPPING = {
    'LEB': {
        'GR': true,
        'ÓV': true,
    },
    'REN': {
        'GR': true,
        'ÓV': true,
    },
    'RENE': {
        'GR': true,
        'ÓV': true,
    },
    'FOR': {
        'GR': true,
        'ÓV': true,
    },
    'FORE': {
        'GR': true,
        'ÓV': true,
    },
    'VID': {
        'GR': true,
        'ÓV': true,
    },
    'VIDE': {
        'GR': true,
        'ÓV': true,
    },
    'VIDT': {
        'GR': true,
        'ÓV': true,
    },
    'VIDTE': {
        'GR': true,
        'ÓV': true,
    },
}

